<header>
  <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
    <a class="navbar-brand" href="#">
      <img src="/assets/img/senx-100-white.png" style="max-height: 40px" alt="TrueSea">
      TrueSea</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse"
            aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarCollapse">
      <div class="d-flex flex-row justify-content-end w-100">
        <div class="text-white custom-slider flex-fill" *ngIf="lastbucket">
          <ngx-slider
            [value]="currentTick"
            (userChangeStart)="sliderChangeStart()"
            (userChangeEnd)="sliderChange($event)"
            [options]="sliderOptions"></ngx-slider>
        </div>
        <form class="form-inline me-1 ms-2 d-flex align-items-center" [formGroup]="paramForm">
          <button class="btn btn-outline-light btn-sm" type="button" (click)="playPauseToggle()" *ngIf="mapData">
            <fa-icon [fixedWidth]="true" icon="play" *ngIf="paused"></fa-icon>
            <fa-icon [fixedWidth]="true" icon="pause" *ngIf="!paused"></fa-icon>
          </button>
          <button class="btn btn-outline-light btn-sm" type="button" (click)="loopToggle()" *ngIf="mapData">
            <fa-icon [fixedWidth]="true" icon="sync" *ngIf="loop"></fa-icon>
            <fa-layers [fixedWidth]="true" *ngIf="!loop">
              <fa-icon icon="sync"></fa-icon>
              <fa-icon icon="slash"></fa-icon>
            </fa-layers>
          </button>
          <div class="ms-2 input-group">
            <div class="input-group-prepend">
              <button class="btn btn-outline-secondary btn-sm" type="button">
                <fa-icon [fixedWidth]="true" icon="anchor"></fa-icon>
              </button>
            </div>
            <label for="locationField"></label>
            <select name="locationField" class="form-select form-select-sm" id="locationField"
                    formControlName="locationField">
              <option *ngFor="let f of locations" [value]="f">{{f}}</option>
            </select>
          </div>
          <div class="ms-2 input-group">
            <div class="input-group-prepend">
              <button class="btn btn-outline-secondary btn-sm" type="button">
                <fa-icon [fixedWidth]="true" icon="hourglass-half"></fa-icon>
              </button>
            </div>
            <label for="durationField"></label>
            <select name="durationField" class="form-select form-select-sm" id="durationField"
                    formControlName="durationField">
              <option *ngFor="let f of durations" [value]="f.val">{{f.label}}</option>
            </select>
          </div>
          <div class="ms-2 form-group">
            <div class="input-group">
              <div class="input-group-prepend">
                <button class="btn btn-outline-secondary btn-sm" (click)="d.toggle()" type="button">
                  <fa-icon [fixedWidth]="true" icon="calendar-alt"></fa-icon>
                </button>
              </div>
              <label for="dateField"></label>
              <input class="form-control form-control-sm" placeholder="yyyy-mm-dd" [maxDate]="maxDate"
                     formControlName="dateField" (click)="d.toggle()"
                     id="dateField"
                     name="dp" ngbDatepicker #d="ngbDatepicker">
            </div>
          </div>
          <button class="btn btn-outline-secondary ms-2 btn-sm" (click)="sidebarOpen = !sidebarOpen"
                  title="Settings">
            <fa-icon [fixedWidth]="true" icon="sliders-h"></fa-icon>
          </button>
          <button class="btn btn-outline-secondary ms-2 btn-sm" (click)="openAbout()"
                  title="About">
            <fa-icon [fixedWidth]="true" icon="info"></fa-icon>
          </button>
        </form>
      </div>
    </div>
  </nav>
</header>

<!-- Begin page content -->
<div class="page-wrapper" [ngClass]="{  'toggled': sidebarOpen}">
  <main role="main" class="flex-shrink-0">
    <app-map></app-map>
    <div class="ship-pic" *ngIf="showPic">
      <img *ngIf="!isImgLoaded" src="assets/img/ship.jpg" alt="ship">
      <img [hidden]="!isImgLoaded" [src]="pic" (load)="isImgLoaded = true" alt="ship">
    </div>
    <div class="selected-ships" [ngClass]="{'show': this.displaySelection}">
      <div class="row">
        <div class="col-auto">
          <h5 class="mt-2 ms-2" *ngIf="selectedShips">{{selectedShips?.length}}
            ship{{selectedShips.length > 1 ? 's' : ''}} in selection</h5>
        </div>
        <div class="col">
          <div id="close-selected-ships" class="text-right me-2 mt-2" (click)="toggleSelection()">
            <fa-icon [fixedWidth]="true" icon="times"></fa-icon>
          </div>
        </div>
      </div>
      <h5 class="mt-2 ms-2" *ngIf="!selectedShips">Loading ships...
        <fa-icon [fixedWidth]="true" icon="circle-notch" [spin]="true"></fa-icon>
      </h5>
      <div class="list-group mt-2 mb-2" *ngIf="selectedShips">
        <app-ship-list [mapParams]="mapParams" [selected]="selectedShips" (onHideBubble)="hideBubble($event)"
                       (onShowBubble)="showBubble($event)"
                       (onOpenParamsModal)="openParamsModal($event)"></app-ship-list>
      </div>
    </div>
  </main>
  <div class="gts" *ngIf="gts">
    <p>
      <fa-icon [fixedWidth]="true" icon="info-circle"></fa-icon>
      Visualizing {{count | number}} positions of {{gts | number}} ships.
    </p>
  </div>
  <nav id="sidebar" class="sidebar-wrapper">
    <div class="sidebar-content">
      <div class="sidebar-brand">
        <h4>
          <fa-icon [fixedWidth]="true" icon="sliders-h"></fa-icon>
          Settings
        </h4>
        <div id="close-sidebar" (click)="sidebarOpen = !sidebarOpen">
          <fa-icon [fixedWidth]="true" icon="times"></fa-icon>
        </div>
      </div>
      <ul class="pickers">
        <li>
          <app-color-picker [color]="mapParams.markerColor" [heading]="'Marker Color'"
                            (event)="setValue('markerColor', $event)"></app-color-picker>
        </li>
        <li>
          <app-color-picker [color]="mapParams.trackColor" [heading]="'Track Color'"
                            (event)="setValue('trackColor', $event)"></app-color-picker>
        </li>
        <li class="custom-slider"><label>Marker Size</label>
          <ngx-slider
            [value]="mapParams.markerSize"
            (userChangeEnd)="setValue('markerSize', $event)"
            [options]="{floor: 0, ceil: 20, showSelectionBar: true }"></ngx-slider>
        </li >
        <li class="custom-slider"><label>Track Width</label>
          <ngx-slider
            [value]="mapParams.trackWidth"
            (userChangeEnd)="setValue('trackWidth', $event)"
            [options]="{floor: 0, ceil: 20, showSelectionBar: true }"></ngx-slider>
        </li>
        <li class="custom-slider"><label>Track Opacity</label>
          <ngx-slider
            [value]="mapParams.trackOpacity"
            (userChangeEnd)="setValue('trackOpacity', $event)"
            [options]="{floor: 0, ceil: 0.1, step: 0.01, showSelectionBar: true }"></ngx-slider>
        </li>
        <li class="custom-slider"><label>Track Length</label>
          <ngx-slider
            [value]="mapParams.transparentThreshold"
            (userChangeEnd)="setValue('transparentThreshold', $event)"
            [options]="{floor: 0, ceil: 256, showSelectionBar: true }"></ngx-slider>
        </li>
        <li class="custom-slider"><label>Speed</label>
          <ngx-slider style="margin-bottom: 4rem;"
                      [value]="mapParams.delay"
                      (userChangeEnd)="setValue('delay', $event)"
                      [options]="{ rightToLeft: true, showTicks: true, translate: translate, stepsArray: [{value:50, legend: 'Quick'}, {value:300}, {value:400}, {value:500}, {value:700}, {value:1000, legend: 'Slow'}] }"></ngx-slider>
        </li>
      </ul>
    </div>
  </nav>
</div>
